export const CompressedImgWidth = 500;
export const CompressedImgHeight = 400;
export const ChangePasswordNowLink = 'ChangePasswordNowLink';



// WEBPACK FOOTER //
// ./src/constants/profile.constants.ts